export const WORK_NUMBER_AFFORDABLE_SWITCH_NAME = 'theWorkNumberAffordable';
